import { Palette } from 'core/config';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import styled from 'styled-components';

export const IconButton = styled.button`
    border: none;
    padding: 0;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const BackArrowIcon = styled(HiOutlineArrowNarrowLeft)`
    font-size: 1.2rem;
    color: ${Palette.BLUE};
`;

export const BackButtonText = styled.span`
    font-size: 1rem;
    font-family: SofiaPro-Regular;
    color: ${Palette.BLUE};

    @media only screen and (max-width: 600px) {
        font-size: 0.8rem;
    }
`;
